document.addEventListener("DOMContentLoaded", function() {

    var fundingSelect = $('#funding_price_id');
    var addToCartButton = $('#add-to-cart-button');
    var yetSelected= false;

    addToCartButton.on('click', function() {

        if (!yetSelected) {
            fundingSelect.find('option:first').prop('selected', true);
            var selectedOption = $(fundingSelect).find('option:selected');
            var multiplier = parseFloat(selectedOption.data("multiplier")).toFixed(2);
            var fundingDescription = selectedOption.data("funding-description");
            var selectedFundingId = selectedOption.val();
            var modalCalculatedPriceElement = $('#modal-calculatedPrice');
            var modalTotalCalculatedElement = $('#modal-total-calculated');

            modalCalculatedPriceElement.text(multiplier);
            modalCalculatedPriceElement.attr("data-total-price", multiplier);

            modalTotalCalculatedElement.text(fundingDescription);

            // document.getElementById('purchasePrice').value = totalPrice;

            $('input[name="funding_type_id"]').val(selectedFundingId);
        }
    });

    fundingSelect.on('change', function() {
        yetSelected = true;

        var selectedOption = $(this).find('option:selected');
        var multiplier = parseFloat(selectedOption.data("multiplier")).toFixed(2);
        var fundingDescription = selectedOption.data("funding-description");
        var selectedFundingId = selectedOption.val();
        var modalCalculatedPriceElement = $('#modal-calculatedPrice');
        var modalTotalCalculatedElement = $('#modal-total-calculated');

        modalCalculatedPriceElement.text(multiplier);
        modalCalculatedPriceElement.attr("data-total-price", multiplier);

        modalTotalCalculatedElement.text(fundingDescription);

        $('input[name="funding_type_id"]').val(selectedFundingId);
    });
});
